export const validateWeekDays = (weekDays) => {
  let daysValid = false;
  for (let option of weekDays) {
    if (option.checked) {
      daysValid = true;
      break;
    }
  }

  return daysValid;
};
